import React from 'react';
import { Route } from 'react-router-dom';
import UserRecovery from '../login/recovery';

export default [
  <Route exact path="/login/recovery" component={UserRecovery} noLayout/>,
];